import fetch from '@/utils/fetch';
//获得学校的阅读平台设置
export function getMsgInitList() {
    return fetch({
        url: 'structure/pushMsg/getMsgInitList',
        method: 'get'
    });
}

export function addMsgInit(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/pushMsg/addMsgInit',
        method: 'POST',
        data: JSON.stringify(args)
    });
}

export function updateMsgInit(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/pushMsg/updateMsgInit',
        method: 'POST',
        data: JSON.stringify(args)
    });
}

export function delMsgInit(moduleCode) {
    const params = new URLSearchParams();
    params.append("moduleCode", moduleCode);
    return fetch({
        url: 'structure/pushMsg/delMsgInit',
        method: 'get',
        params
    })
}

export function getMsgInit(moduleCode) {
    const params = new URLSearchParams();
    params.append("moduleCode", moduleCode);
    return fetch({
        url: 'structure/pushMsg/getMsgInit',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/api/releaseModule.js